
































import { Component, Vue, Watch } from 'vue-property-decorator';
import PendingFunds from '@/components/payment/PendingFunds.vue';
import ActiveFunds from '@/components/payment/ActiveFunds.vue';
import { Action } from 'vuex-class';
import { OrderSummary } from '@/interfaces/OrderSummary';
import { TJsonApiBody } from 'jsona/lib/JsonaTypes';
import Jsona from 'jsona';

const dataFormatter = new Jsona();

@Component({
    name: 'Payment',
    components: {
        PendingFunds,
        ActiveFunds,
    },
})
export default class Payment extends Vue {
    protected get activeCheckoutMethod() {
        return this.$store.getters['user/activeCheckoutMethod'];
    }

    protected get activeProductGroup() {
        return this.$store.getters['user/activeProductGroup'];
    }

    protected get billingAddresses() {
        return this.$store.getters['user/billingAddresses'];
    }

    protected get activeComponent() {
        const routeParam = this.$route.params.type;
        const activeCheckoutMethod = this.activeCheckoutMethod;
        // @ts-ignore
        if (this.pendingFunds[routeParam] || this.pendingFunds[activeCheckoutMethod]) {
            // @ts-ignore
            this.checkoutMethod = this.pendingFunds[routeParam] || this.pendingFunds[activeCheckoutMethod];
            return 'PendingFunds';
        }
        // @ts-ignore
        this.checkoutMethod = this.activeFunds[activeCheckoutMethod];
        return 'ActiveFunds';
    }

    @Action('user/getBillingAddresses')
    protected getBillingAddresses!: () => void;

    protected pendingFunds = {
        subscriptions: 'buySubscription',
        credits: 'buyPrepaidCredit',
        'pay as you go': 'usePayPerView',
    };
    protected activeFunds = {
        subscription: 'useSubscription',
        prepaid: 'usePrepaid',
    };

    protected orderSummary: OrderSummary | null = null;
    protected checkoutMethod = '';
    @Action('user/getCartSummary') private getCartSummary!: (
        payload: CartSummaryRequest,
    ) => Promise<TJsonApiBody | string>;

    protected onBillingAddressChange(orderSummary: OrderSummary) {
        this.orderSummary = orderSummary;
    }

    protected fetchCartData() {
        if (
            this.checkoutMethod === 'useSubscription' ||
            this.checkoutMethod === 'usePrepaid' ||
            this.checkoutMethod === 'usePayPerView'
        ) {
            this.getCartSummary({
                type: this.checkoutMethod,
            }).then((response) => {
                this.orderSummary = dataFormatter.deserialize(
                    response,
                ) as OrderSummary;
            });
        }
    }

    @Watch('checkoutMethod')
    protected async onChangeCheckoutMethod() {
        this.fetchCartData();
    }

    @Watch('activeProductGroup')
    protected async onChangeProductGroup() {
        this.fetchCartData();
    }
}
